import { createContext, useContext } from "react";
import useContentResource from "../hooks/useContentResource";
import { fallbackNavigation, fallbackSiteSettings } from "../services/fallback/contentFallbacks";
import { getNavigation } from "../services/content/navigation.service";
import { getSiteSettings } from "../services/content/settings.service";

const SiteDataContext = createContext({
  settings: fallbackSiteSettings,
  navigation: fallbackNavigation.items,
  loading: true,
  usingFallback: false,
});

export function SiteDataProvider({ children }) {
  const settingsState = useContentResource(
    ({ signal }) => getSiteSettings({ signal }),
    []
  );
  const navigationState = useContentResource(
    ({ signal }) => getNavigation({ signal }),
    []
  );

  const value = {
    settings: settingsState.data || fallbackSiteSettings,
    navigation: navigationState.data?.items || fallbackNavigation.items,
    loading: settingsState.loading || navigationState.loading,
    usingFallback: settingsState.usedFallback || navigationState.usedFallback,
  };

  return (
    <SiteDataContext.Provider value={value}>
      {children}
    </SiteDataContext.Provider>
  );
}

export function useSiteData() {
  return useContext(SiteDataContext);
}
